export const hideNotification = () => ({
  type: 'NOTIF_HIDE',
})



// WEBPACK FOOTER //
// ./src/components/Notification/actions.js